var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTie = function SvgTie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "tie_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m45.077 2.5-5.97 13.432 7.608 30.431L32 61.078 17.285 46.363l7.608-30.431L18.923 2.5zm-15.97 13.067-7.392 29.57L32 55.422l10.284-10.285-7.391-29.57 4.03-9.067H25.077z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37 13.75v4H27v-4z"
  })));
};
export { SvgTie as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNDUuMDc3MSAyLjVMMzkuMTA2NCAxNS45MzE2TDQ2LjcxNDggNDYuMzYzM0wzMiA2MS4wNzgxTDE3LjI4NTIgNDYuMzYzM0wyNC44OTI2IDE1LjkzMTZMMTguOTIyOSAyLjVINDUuMDc3MVpNMjkuMTA3NCAxNS41Njc0TDIxLjcxNDggNDUuMTM2N0wzMiA1NS40MjE5TDQyLjI4NDIgNDUuMTM2N0wzNC44OTI2IDE1LjU2NzRMMzguOTIyOSA2LjVIMjUuMDc3MUwyOS4xMDc0IDE1LjU2NzRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMzcgMTMuNzVWMTcuNzVIMjdWMTMuNzVIMzdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";